import { auth } from 'lib/firebase/firebase';

export const getAuthToken = async (): Promise<string> => {
    // User should be present in indexedDb for client and cookies.token for server
    const { currentUser } = auth();
    const authToken = currentUser ? await currentUser.getIdToken() : null;
    return authToken;
};
